export default __webpack_public_path__ + "static/media/Top_Front Page_Family.acb6fa9d.jpg";